import React, { useEffect, useState } from "react";
import Nav from "../components/Nav/Nav";
import { ArrowLeftOutlined, LoadingOutlined } from "@ant-design/icons";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

import "../App.css";

function PaymentSettings() {
  const navigate = useNavigate();
  const { id } = useParams();

  const {
    currentUser,
    currentRestaurant,
    getRestaurant,
    updateRestaurant,
    isLoading,
    platformSettings,
    restaurantM
  } = useAuth();

  const [paymentEnabled, setPaymentEnabled] = useState(false);
  const [deliveryEnabled, setDeliveryEnabled] = useState(true);
  const [deliveryFee, setDeliveryFee] = useState(0);
  const [minOrderPrice, setMinOrderPrice] = useState(10);

  const [enableTable, setEnableTable] = useState(false);
  const [enableTakeaway, setEnableTakeaway] = useState(false);

  const [deliveryTimeValue, setDeliveryTimeValue] = useState(15);
  const [deliveryTimeUnit, setDeliveryTimeUnit] = useState("minutes");
  const isDigitalProduct = currentRestaurant?.productType === "digital";

  useEffect(() => {
    getRestaurant(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (
      currentUser &&
      currentRestaurant &&
      currentRestaurant.owner !== currentUser.uid
    ) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser, currentRestaurant]);

  useEffect(() => {
    if (!currentRestaurant) return;

    setPaymentEnabled(!!currentRestaurant.paymentEnabled);

    setDeliveryEnabled(currentRestaurant.deliveryEnabled !== false);
    setDeliveryFee(currentRestaurant.deliveryFee || 0);
    setMinOrderPrice(currentRestaurant.minOrderPrice || 10);

    setEnableTable(false);
    setEnableTakeaway(false);

    if (currentRestaurant.deliveryTimeValue) {
      setDeliveryTimeValue(currentRestaurant.deliveryTimeValue);
    } else if (currentRestaurant.preparationTime) {
      setDeliveryTimeValue(currentRestaurant.preparationTime);
    } else {
      setDeliveryTimeValue(15);
    }

    setDeliveryTimeUnit(currentRestaurant.deliveryTimeUnit || "minutes");
  }, [currentRestaurant]);

  const handleSubmit = (e) => {
    e.preventDefault();
  
    const isDigitalProduct = currentRestaurant?.productType === "digital";
  
    const safeDeliveryFee =
      paymentEnabled && deliveryEnabled && !isDigitalProduct
        ? Math.max(0, Number(deliveryFee || 0))
        : 0;
  
    updateRestaurant(
      id,
      currentUser.uid,
      currentRestaurant.name,
      currentRestaurant.adress,
      currentRestaurant.type,
      currentRestaurant.hours,
      currentRestaurant.review,
      currentRestaurant.photo,
      currentRestaurant.status,
      currentRestaurant.isOpen,
      currentRestaurant.defaultL,
      currentRestaurant.translated,
      currentRestaurant.social,
      currentRestaurant.contact || {},
      currentRestaurant.productType || "physique",
      paymentEnabled,
      deliveryEnabled,
      safeDeliveryFee,
      paymentEnabled ? Math.max(10, Number(minOrderPrice || 10)) : 0,
      enableTable,
      enableTakeaway,
      deliveryEnabled,
      paymentEnabled ? Number(deliveryTimeValue || 0) : 0,
      deliveryTimeUnit
    );
  };

  return (
    <div className="one-page">
      <Nav />

      <div className="main">
        <form onSubmit={handleSubmit} className="wrapper-container">
          <div className="wrapper-content">
            <div className="title-wrapper">
              <div className="title-back">
                <ArrowLeftOutlined
                  onClick={() => navigate(-1)}
                  className="back"
                />
                <p>Paiement et livraison</p>
              </div>
            </div>

            <div className="wrapper-form">
              <div className="input-container">
                <label>Activer le paiement</label>
                <select
                  value={String(paymentEnabled)}
                  onChange={(e) => setPaymentEnabled(e.target.value === "true")}
                >
                  <option value="true">Oui</option>
                  <option value="false">Non</option>
                </select>
              </div>

              {paymentEnabled && (
                <>
                  <div className="input-container">
                    <label>Commission plateforme</label>
                    <input
                      value={platformSettings?.commissionLabel || ""}
                      disabled
                    />
                  </div>

                  <div className="input-container">
                    <label>Commande minimum</label>
                    <input
                      type="number"
                      min="10"
                      step="0.01"
                      value={minOrderPrice}
                      onChange={(e) => setMinOrderPrice(e.target.value)}
                    />
                  </div>

                  {!isDigitalProduct && (
  <div className="input-container">
    <label>Activer la livraison</label>
    <select
      value={String(deliveryEnabled)}
      onChange={(e) =>
        setDeliveryEnabled(e.target.value === "true")
      }
    >
      <option value="true">Oui</option>
      <option value="false">Non</option>
    </select>
  </div>
)}

{!isDigitalProduct && deliveryEnabled && (
  <>
    <div
      className="input-container"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <label>Durée de livraison</label>

      <div style={{ display: "flex", width: "60%", gap: 10 }}>
        <input
          type="number"
          min="0"
          value={deliveryTimeValue}
          onChange={(e) => setDeliveryTimeValue(e.target.value)}
          style={{ flex: 1 }}
        />

        <select
          value={deliveryTimeUnit}
          onChange={(e) => setDeliveryTimeUnit(e.target.value)}
          style={{ width: "120px" }}
        >
          <option value="minutes">Minutes</option>
          <option value="hours">Heures</option>
        </select>
      </div>
    </div>

    <div className="input-container">
      <label>Frais de livraison</label>
      <input
        type="number"
        min="0"
        step="0.01"
        value={deliveryFee}
        onChange={(e) =>
          setDeliveryFee(Math.max(0, Number(e.target.value || 0)))
        }
      />
    </div>
  </>
)}
                 
                </>
              )}

              <div className="input-container" style={{ display: "none" }}>
                <label>Service à table</label>
                <select
                  value={String(enableTable)}
                  onChange={(e) => setEnableTable(e.target.value === "true")}
                >
                  <option value="true">Oui</option>
                  <option value="false">Non</option>
                </select>
              </div>

              <div className="input-container" style={{ display: "none" }}>
                <label>À emporter</label>
                <select
                  value={String(enableTakeaway)}
                  onChange={(e) => setEnableTakeaway(e.target.value === "true")}
                >
                  <option value="true">Oui</option>
                  <option value="false">Non</option>
                </select>
              </div>

              <div className="validation-container">
                <button className="button save" type="submit">
                  {isLoading ? <LoadingOutlined spin /> : "Enregistrer"}
                </button>
                {restaurantM && <div className="delete info">{restaurantM}</div>}
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default PaymentSettings;